import React from 'react';
import { DetailsPanel } from '@quyva/shared-ui';

export const AgentsUpdatesDetailsPane = ({
    selectedRow,
    setSelectedRowId,
    renderStatusPill,
}) => {
    if (!selectedRow) {
        return (
            <div className='w-full h-full flex items-center justify-center text-sm text-texts-secondary300'>
                Select an agent execution to view updates.
            </div>
        );
    }

    const executionType =
        String(selectedRow.executionType || '').toUpperCase() === 'ASYNC'
            ? 'ASYNC'
            : String(selectedRow.executionType || '').toUpperCase() === 'SYNC'
            ? 'SYNC'
            : '';

    const title = selectedRow.agentName
        ? `${selectedRow.agentName}${executionType ? ` [${executionType}]` : ''}`
        : 'Agent Execution';
    const subtitle = selectedRow.queryHeading ? `(${selectedRow.queryHeading})` : '';

    const raw = typeof selectedRow.message === 'string' ? selectedRow.message : '';
    const parts = raw
        .split('\n\n')
        .map((p) => p.trim())
        .filter(Boolean);

    return (
        <DetailsPanel
            title={title}
            subtitle={subtitle}
            onClose={() => setSelectedRowId(null)}
            className='rounded-r-xl rounded-l-none overflow-hidden border border-backgrounds-border'
            headerClassName='!bg-[#f1f5f9]'
            titleClassName='text-sm font-semibold text-texts-secondary'
            subtitleClassName='mt-0.5 text-xs text-texts-secondary300'
            contentClassName='overflow-x-hidden'
            statusBar={
                <div className='px-4 py-3 border-b border-backgrounds-border flex flex-wrap items-center gap-2 text-xs text-texts-secondary300 bg-backgrounds-primary100/60'>
                    {renderStatusPill(selectedRow.status)}
                    {String(selectedRow.userType).toLowerCase() ===
                        'organization admin' && (
                        <span
                            className='px-2 py-1 rounded-md font-medium border whitespace-nowrap bg-green-100 text-green-800 border-green-200'
                        >
                            {selectedRow.userType}
                        </span>
                    )}
                    <span className='px-2 py-1 rounded-md border whitespace-nowrap bg-backgrounds-slate text-texts-secondary300 border-backgrounds-border'>
                        User: {selectedRow.userId}
                    </span>
                </div>
            }
        >
            <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
                <div className='bg-backgrounds-white rounded-lg border border-backgrounds-border px-4 py-3'>
                    <div className='text-xs font-semibold text-texts-secondary300 mb-1'>
                        Start time
                    </div>
                    <div className='text-sm text-texts-secondary'>
                        {selectedRow.creationTime || '-'}
                    </div>
                </div>

                <div className='bg-backgrounds-white rounded-lg border border-backgrounds-border px-4 py-3'>
                    <div className='text-xs font-semibold text-texts-secondary300 mb-1'>
                        Completion time
                    </div>
                    <div className='text-sm text-texts-secondary'>
                        {selectedRow.completionTime || '------'}
                    </div>
                </div>
            </div>

            <div className='bg-backgrounds-white rounded-lg border border-backgrounds-border px-4 py-3'>
                <div className='text-xs font-semibold text-texts-secondary300 mb-1'>
                    Updates
                </div>
                <div className='space-y-1 text-sm text-texts-secondary'>
                    {selectedRow.lastUpdateTime && (
                        <div className='text-xs text-texts-secondary300'>
                            Last update: {selectedRow.lastUpdateTime}
                        </div>
                    )}

                    {parts.length ? (
                        <ul className='list-disc list-inside space-y-0.5 text-xs text-texts-secondary300'>
                            {parts.map((p, idx) => (
                                <li
                                    key={idx}
                                    className='break-words text-texts-secondary300'
                                >
                                    {p}
                                </li>
                            ))}
                        </ul>
                    ) : (
                        <div className='break-words text-xs text-texts-secondary300'>
                            No updates.
                        </div>
                    )}
                </div>
            </div>
        </DetailsPanel>
    );
};
